import {Component, ViewChild} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {KeyLog} from '../../../types/data.types';
import {DirectoryService} from '../../../services/directory.service';
import {KeyLogService} from '../../../services/key-log.service';

declare const $: any;
declare const toastr: any;
declare const swal: any;

@Component({
    selector: 'key-log-detailed-view',
    templateUrl: './key-log-detailed-view.component.html',
    styleUrls: ['./key-log-detailed-view.component.scss']
})

export class KeyLogDetailedViewComponent {
    @ViewChild('form') form;
    title = 'Resident';
    disabledFileInput = false;
    data: KeyLog;
    navPosition = 'details';
    noEdit = false;
    suites = [];
    buildingSelectIsDisabled = false;

    constructor(public api: ApiClientService,
                public keyLogService: KeyLogService,
                public directoryService: DirectoryService) {
    }

    onSubmit(data: any): void {
        this.noEdit = true;
        const url = `/v1/key_log/${this.keyLogService.selectedItemData.id}.json`;
        this.keyLogService.api.patch('domainKeyLog', url, data).subscribe(
            () => this.updateView('The Field was successfully updated', false),
            () => toastr.error('Update failed!'),
            () => this.noEdit = false
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        // this.keyLogService.toggleDetailedView(this.keyLogService.selectedItemData);
        this.keyLogService.getData();
        if (close)
            this.keyLogService.toggleDetailedView(null);
    }

    setEditModeFor(item, fieldName: string, state: boolean) {
        this.setEditModeForAll(false);
        item.formFields[fieldName].editMode = state;
    }

    setEditModeForAll(state: boolean) {
        for(const field in this.keyLogService.selectedItemData.formFields)
            this.keyLogService.selectedItemData.formFields[field].editMode = state;
    }

    applyChanges(item, form, changedValue, formField) {
        let valueToSend = changedValue;
        if (changedValue.shareContact === 'true')
            valueToSend.shareContact = 1;
        else if (changedValue.shareContact === 'false')
            valueToSend.shareContact = 0;

        if (changedValue.requestType) {
            if (changedValue.requestType.length == 1 && changedValue.requestType != '0')
                valueToSend = {serviceRequestType: changedValue.requestType};
            else
                valueToSend = {serviceRequestTypeOther: changedValue.requestType};
        }

        if (form.dirty) {
            item[formField] = form.value[formField];
            if (form.valid) this.setEditModeForAll(false);
            this.onSubmit(valueToSend);
        } else {
            this.setEditModeForAll(false);
        }
    }

    getBuildingNameById(id): string {
        let name = '';

        this.keyLogService.buildings.forEach(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    changeNavPosition(changeTo): void {
        this.navPosition = changeTo;
    }

    changeBuilding(buildingId: string) {
        this.form.controls['suiteId'].reset();
        this.getSuites(+buildingId);
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        this.suites = [];
        this.buildingSelectIsDisabled = true;
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                suites.forEach(
                    suite => this.suites.push({id: suite.id, name: suite.suiteNumber})
                );
                this.suites.push({id: 0, name: 'Other'});
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    submitUnitField() {
        if (!this.form.value.buildingId) {
            toastr.warning('Building should not be blank.');
            return;
        }
        if (!this.form.value.suiteId && this.form.value.suiteId !== 0) {
            toastr.warning('Unit should not be blank.');
            return;
        }
        const building = this.keyLogService.buildings.find((item) => item.id == this.form.value.buildingId);
        const suite    = this.suites.find((item) => item.id == this.form.value.suiteId);
        const data = {
            building: {
                bdId: this.form.value.buildingId,
                name: building ? building.name : null,
            },
            suite: {
                bdId:        suite.id ? this.form.value.suiteId : 0,
                suiteNumber: suite.id ? suite.name : this.form.value.otherSuite,
            },
        };
        this.noEdit = true;
        const url = `/v1/key_log/${this.keyLogService.selectedItemData.id}.json`;
        this.keyLogService.api.patch('domainKeyLog', url, data).subscribe(
            res => {
                this.updateView('The Field was successfully updated', false);
                this.keyLogService.selectedItemData.buildingId = building.id;
                this.keyLogService.selectedItemData.buildingName = building.name;
                this.keyLogService.selectedItemData.suiteId = suite.id;
                this.keyLogService.selectedItemData.suiteNumber = suite.id ? suite.name : this.form.value.otherSuite;
                this.keyLogService.selectedItemData.formFields.unit.editMode = false;
            },
            () => toastr.error('Update failed!'),
            () => this.noEdit = false
        );
    }

    turnEditModeOn() {
        if(this.keyLogService.selectedItemData.isCanEdit && !this.noEdit) {
            this.keyLogService.selectedItemData.formFields.unit.editMode = true;
            this.getSuites(this.keyLogService.selectedItemData.buildingId);
        }
    }

    changeUnit(suiteId: string) {
        if (suiteId + '' === '0')
            setTimeout(() => this.form.controls['otherSuite'].reset(), 0);
    }

    actionButtonIsNotAvailable() {
        return !(this.keyLogService.selectedItemData.isCanEdit || this.keyLogService.selectedItemData.isCanDelete);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/key-log/key-log-detailed-view/key-log-detailed-view.component.ts